"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonBase = exports.Button = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var react_1 = tslib_1.__importStar(require("react"));

var inner_1 = require("./partials/inner");

var root_1 = require("./styled/root");

var Button = (0, react_1.forwardRef)(function (_a, ref) {
  var __UIScope = _a.__UIScope,
      children = _a.children,
      className = _a.className,
      disabled = _a.disabled,
      isOutlined = _a.isOutlined,
      isLoading = _a.isLoading,
      isGhost = _a.isGhost,
      leadingIcon = _a.leadingIcon,
      _b = _a.pattern,
      pattern = _b === void 0 ? 'primary' : _b,
      _c = _a.size,
      size = _c === void 0 ? 'medium' : _c,
      trailingIcon = _a.trailingIcon,
      _m = _a.m,
      _mb = _a.mb,
      _ml = _a.ml,
      _mr = _a.mr,
      _mt = _a.mt,
      _mx = _a.mx,
      _my = _a.my,
      _p = _a.p,
      _pb = _a.pb,
      _pl = _a.pl,
      _pr = _a.pr,
      _pt = _a.pt,
      _px = _a.px,
      _py = _a.py,
      props = tslib_1.__rest(_a, ["__UIScope", "children", "className", "disabled", "isOutlined", "isLoading", "isGhost", "leadingIcon", "pattern", "size", "trailingIcon", "m", "mb", "ml", "mr", "mt", "mx", "my", "p", "pb", "pl", "pr", "pt", "px", "py"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Button',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var asGhostButton = isGhost && pattern !== 'secondary';

  if ('href' in props) {
    var href = props.href,
        onClick = props.onClick,
        restOfATagProps = tslib_1.__rest(props, ["href", "onClick"]);

    var propsDependentOnDisabled = disabled ? {
      'aria-disabled': true,
      role: 'link'
    } : {
      href: href,
      onClick: onClick
    };
    return react_1.default.createElement(root_1.Root, tslib_1.__assign({
      ref: ref,
      size: size,
      pattern: pattern,
      as: "a",
      className: rootClasses,
      isLeading: !!leadingIcon,
      isTrailing: !!trailingIcon,
      isOutlined: asGhostButton || isOutlined,
      isLoading: isLoading,
      isGhost: isGhost
    }, propsDependentOnDisabled, restOfATagProps), react_1.default.createElement(inner_1.Inner, {
      isOutlined: isOutlined,
      leadingIcon: leadingIcon,
      trailingIcon: trailingIcon,
      isLoading: isLoading,
      pattern: pattern,
      size: size
    }, children));
  }

  return react_1.default.createElement(root_1.Root, tslib_1.__assign({
    ref: ref,
    size: size,
    pattern: pattern,
    disabled: disabled,
    className: rootClasses,
    "aria-disabled": Boolean(disabled),
    isLeading: !!leadingIcon,
    isTrailing: !!trailingIcon,
    isOutlined: asGhostButton || isOutlined,
    isLoading: isLoading,
    isGhost: isGhost
  }, props), react_1.default.createElement(inner_1.Inner, {
    isOutlined: asGhostButton || isOutlined,
    leadingIcon: leadingIcon,
    trailingIcon: trailingIcon,
    isLoading: isLoading,
    pattern: pattern,
    size: size
  }, children));
});
exports.ButtonBase = Button;
Button.displayName = 'Button';
var ButtonWithSpace = (0, ui_helper_with_space_1.withSpace)(Button);
exports.Button = ButtonWithSpace;